import initializeForm from './initializeForm';
import openModal from './openModal';

export default (filterData) => (dispatch) => {
    dispatch(initializeForm({ filterData }));
    dispatch(openModal(true));
};
